import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    state: {
        loading: false,
    },
    mutations: {
        setLoading(state, value) {
            state.loading = value;
        },
    },
    actions: {
        loadPaymentConfiguration({ commit }, options) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query getAdyenPaymentConfiguration(
                            $basketTotal: Float!
                            $country: String!
                            $currency: String!
                            $language: String!
                        ) {
                            getAdyenPaymentConfiguration(
                                basketTotal: $basketTotal
                                country: $country
                                currency: $currency
                                language: $language
                            ) {
                                clientKey
                                paymentMethods
                                isLiveEnv
                                fees
                            }
                        }
                    `,
                    variables: options,
                })
                .then(r => r.data)
                .then(data => {
                    if (data.getAdyenPaymentConfiguration) {
                        return data.getAdyenPaymentConfiguration;
                    }
                })
                .catch(e => {
                    let message = '';
                    if (e.graphQLErrors && e.graphQLErrors.length && e.graphQLErrors[0].message) {
                        if (e.graphQLErrors[0].message === 'cancelled') {
                            throw e.graphQLErrors[0].message;
                        }
                        message += ' ' + e.graphQLErrors[0].message;
                    }
                    commit('Payment/setError', message, { root: true });
                });
        },
        executePayment({ commit }, options) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query executeAdyenPayment(
                            $paymentData: JSON!
                            $orderId: Int!
                            $transactionId: String!
                            $paymentMethod: String
                            $language: String!
                        ) {
                            executeAdyenPayment(
                                paymentData: $paymentData
                                orderId: $orderId
                                transactionId: $transactionId
                                paymentMethod: $paymentMethod
                                language: $language
                            ) {
                                resultCode
                                pspReference
                                refusalReason
                                action
                                paymentData
                                success
                            }
                        }
                    `,
                    variables: options,
                    fetchPolicy: 'no-cache',
                })
                .then(r => r.data.executeAdyenPayment)
                .then(data => {
                    if (
                        data.resultCode === 'Authorised' ||
                        data.resultCode === 'Pending' ||
                        data.resultCode === 'Received'
                    ) {
                        return data;
                    } else if (data.resultCode === 'Cancelled') {
                        commit('setLoading', false);
                        commit('Payment/setError', 'Payment was cancelled', { root: true });
                    } else if (data.refusalReason) {
                        commit('setLoading', false);
                        commit('Payment/setError', data.refusalReason, { root: true });
                    } else if (data.resultCode === 'RedirectShopper' && data.action && data.action.url) {
                        if (data.action.method === 'GET') {
                            window.location.href = data.action.url;
                        } else {
                            let form = document.createElement('form');
                            form.action = data.action.url;
                            form.method = 'POST';
                            if (data.action.hasOwnProperty('data')) {
                                const inputs = [];
                                Object.keys(data.action.data).forEach(key => {
                                    inputs.push(`<input name="${key}" value="${data.action.data[key]}">`);
                                });
                                form.innerHTML = inputs.join(' ');
                            }
                            document.body.append(form);
                            form.submit();
                        }
                    } else {
                        commit('setLoading', false);
                        commit('Payment/setError', 'Something went wrong while confirming the payment.', {
                            root: true,
                        });
                    }
                })
                .catch(e => {
                    commit('setLoading', false);
                    commit('Payment/setError', 'Something went wrong during the payment execution.', { root: true });
                });
        },
        confirmPayment({ commit }, options) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query confirmAdyenPayment($paymentData: JSON!, $transactionId: String!) {
                            confirmAdyenPayment(paymentData: $paymentData, transactionId: $transactionId) {
                                resultCode
                                pspReference
                                refusalReason
                                action
                                paymentData
                                success
                            }
                        }
                    `,
                    variables: options,
                })
                .then(r => r.data.confirmAdyenPayment)
                .then(data => {
                    if (
                        data.resultCode === 'Authorised' ||
                        data.resultCode === 'Pending' ||
                        data.resultCode === 'Received'
                    ) {
                        return data;
                    } else if (data.resultCode === 'Cancelled') {
                        commit('Payment/setError', 'Payment was cancelled', { root: true });
                    } else if (data.refusalReason) {
                        commit('Payment/setError', data.refusalReason, { root: true });
                    } else if (data.resultCode === 'RedirectShopper' && data.action && data.action.url) {
                        if (data.action.method === 'GET') {
                            window.location.href = data.action.url;
                        } else {
                            let form = document.createElement('form');
                            form.action = data.action.url;
                            form.method = 'POST';
                            if (data.action.hasOwnProperty('data')) {
                                const inputs = [];
                                Object.keys(data.action.data).forEach(key => {
                                    inputs.push(`<input name="${key}" value="${data.action.data[key]}">`);
                                });
                                form.innerHTML = inputs.join(' ');
                            }
                            document.body.append(form);
                            form.submit();
                        }
                    } else {
                        commit('Payment/setError', 'Something went wrong while confirming the payment.', {
                            root: true,
                        });
                    }
                })
                .catch(e => {
                    let message = 'Something went wrong during the payment confirmation. <br />';
                    if (e.graphQLErrors && e.graphQLErrors.length && e.graphQLErrors[0].message) {
                        if (e.graphQLErrors[0].message === 'cancelled') {
                            throw e.graphQLErrors[0].message;
                        }
                        message += ' ' + e.graphQLErrors[0].message;
                    }
                    commit('Payment/setError', message, { root: true });
                });
        },
    },
};
